import React from 'react';
import { useSelector } from "react-redux";
import { datetime } from '../../../../../util/library/datetime';
import { selectOpMode } from "../../../../../util/store/selectors";
import { durationTxt, getStartFinishByOpMode } from "../../../../../util/varibles/global";
import { IActivityLog } from "../../../../../util/varibles/interface";
import Icon, { ICON_NAME } from "../../../../Icon";
import stylesContainer from "../../style.module.scss";

interface IProps {
    activity_log: IActivityLog[]
}

const TimeDuration: React.FC<IProps> = (props) => {
    const { activity_log } = props;
    const opMode = useSelector(selectOpMode);
    const { start, finish } = getStartFinishByOpMode[opMode](activity_log)

    return <div className={[stylesContainer['container-box'], 'mb-[5px]'].join(' ')} data-icon={true}>
        <Icon icon={ICON_NAME.CLOCK} style={{ marginTop: '4px', marginLeft: '2px' }} />
        <div data-lev='name'>Time, duration:</div>
        <div className='font-w4 flex items-center gap-1'>
            <div className='flex items-center'>
                <div>{datetime(start).format('DD/MM hh:mm')}</div>
                <div className='arrow-right' />
                <div>{datetime(finish).format('DD/MM hh:mm')}</div>
            </div>
            <div>-</div>
            <div title='Duration'>{durationTxt(finish - start)}</div>
        </div>
    </div>;
};

export default TimeDuration;